<script setup>
import { Link, Head } from '@inertiajs/vue3';

// import { NRFeedback } from "@node/components-vue3";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";

const props = defineProps({
    title: {
        required: true,
        type: String,
    }
});
</script>

<template>
    <v-app>
        <Head :title="title"></Head>
        <div class="tw-bg-textColored tw-h-60 tw-border tw-border-b-8 tw-border-b-primary tw-flex tw-justify-center">
            <ApplicationLogo class="md:tw-h-32 tw-mt-auto tw-mb-auto tw-aspect-[1018/219]"></ApplicationLogo>
        </div>

        <v-container>
            <!-- <NRFeedback></NRFeedback> -->
            <slot></slot>
        </v-container>
    </v-app>
</template>
